export default __webpack_public_path__ + "static/media/Antonia.a9c363b8.png";